<template>
  <v-container fluid>
    <v-layout align-center justify-space-around row fill-height>
      <v-flex xs9 sm6 md6 lg3 xl3>
        <LoginForm
          v-on:submitlogin="handleSubmit"
          v-bind:authResult="authenticationError"
          v-bind:showProgress="authenticating"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginForm from '../components/LoginForm';
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        auth: {
            type: String
        }
    },
    components: {
        LoginForm
    },
    computed: {
        ...mapGetters('auth', ['authenticating', 'authenticationError', 'authenticationErrorCode'])
    },
    methods: {
        ...mapActions('auth', ['login', 'logout', 'loginWithToken']),
        ...mapActions('user', ['loadUserData', 'clearUserData']),
        async handleSubmit({ login, password }) {
            // Perform a simple validation that login and password have been typed in
            if (this.login != '' && this.password != '') {
                if (await this.login({ login: login, password: password })) {
                    await this.loadUserData();
                    this.$store.dispatch('toolbar/reloadMenuItems');
                }
            }
        },
        async loginUserByToken() {
            if (this.auth) {
                if (await this.loginWithToken(this.auth)) {
                    await this.loadUserData();
                    this.$store.dispatch('toolbar/reloadMenuItems');
                }
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(async function(vm) {
            await vm.loginUserByToken();
            next();
        });
    },
    mounted() {}
};
</script>
